import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/new/home_time.png'
import _imports_1 from '@/assets/img/new/home_liveing.gif'
import _imports_2 from '@/assets/img/new/null_icon.png'


const _withScopeId = n => (_pushScopeId("data-v-75dbd36e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user_page" }
const _hoisted_2 = { class: "home_box" }
const _hoisted_3 = { class: "collect_box" }
const _hoisted_4 = { class: "nav_list" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "main_scroll" }
const _hoisted_7 = {
  key: 0,
  class: "curriculumDiv"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "video_img" }
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 2,
  class: "video_update"
}
const _hoisted_13 = {
  key: 3,
  class: "video_update"
}
const _hoisted_14 = {
  key: 0,
  class: "video_status"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_16 = {
  key: 1,
  class: "video_status"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_18 = {
  key: 2,
  class: "video_status"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_20 = { class: "video_title" }
const _hoisted_21 = { class: "tit_name" }
const _hoisted_22 = { class: "video_name" }
const _hoisted_23 = { class: "video_span" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = {
  key: 1,
  class: "null_box"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "暂无数据", -1))
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = {
  key: 2,
  class: "pagin_box pagin_box1"
}
const _hoisted_30 = { class: "pagin_tiao" }

import { onMounted, reactive } from 'vue'
import { useRoute,useRouter } from 'vue-router'
import { useStore } from 'vuex';
import { getRecordCourse, getLiveCourse } from '@/api/myCourse'
import { TMyRecordType } from '@/module/myCourse'
import { TResponse, TTotal } from '@/module/common';

export default /*#__PURE__*/_defineComponent({
  __name: 'myCourse',
  setup(__props) {

const store = useStore()
const router = useRouter();
const person: any = reactive ({
    data: {
      list: [],
      PageIndex: 1,
      PageSize: 8,
      total:0
    },
    navList:[
        { name: '录播' },
        { name: '直播' }
    ],
    navActive:0,
    imgs: [require('@/assets/img/new/course_1.png'), require('@/assets/img/new/course_2.png'), require('@/assets/img/new/course_3.png')]
})

onMounted(() => {
    // 判断是主页，头部不加背景色
    if (router.currentRoute.value.name !== 'teaIndex') {
        store.commit('setIsBg', true)
    }
    GetRecordCourse()
})
// 切换展示
const navChange=(item:any,index:number)=>{
    person.navActive=index
    if (person.navActive === 0){
        GetRecordCourse()
    }else{
        GetLiveCourse()
    }
}
// 获取我的录播课程
const GetRecordCourse = async () => {
    let res: TResponse<TTotal<TMyRecordType[]>> = await getRecordCourse({ PageIndex: person.data.PageIndex, PageSize: person.data.PageSize })
    let { Code, Data } = res
    if (Code === 200) {
        person.data.list = Data.Data
        person.data.total = Data.Total
    }
}
// 获取我的直播课程
const GetLiveCourse = async () => {
    let res: TResponse<TTotal<TMyRecordType[]>> = await getLiveCourse({ PageIndex: person.data.PageIndex, PageSize: person.data.PageSize })
    let { Code, Data } = res
    if (Code === 200) {
        person.data.list = Data.Data
        person.data.total = Data.Total
    }
}

let toStudy = (item: any) => {
    if (item.PlayStatus) { // 直播
        let obj = { NodeId: item.Id, Id: item.Id, IsCollect: -1 }
        localStorage.setItem('setId', JSON.stringify(obj))
        router.push({ name: 'liveDetails' })
    } else { // 录播
        let obj = { NodeId: item.Id, Id: item.Id, IsCollect: -1 }
        localStorage.setItem('setId', JSON.stringify(obj))
        let obj1 = { isOpenClass:true }
        localStorage.setItem('openClass', JSON.stringify(obj1))
        router.push({ name: 'recordDetails' })
    }
}
// 分页
const currentChange = (val: number) => {
    person.data.PageIndex = val
    GetRecordCourse()
}

return (_ctx: any,_cache: any) => {
  const _component_ArrowLeft = _resolveComponent("ArrowLeft")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "seachTop",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).back()))
        }, [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_component_ArrowLeft)
            ]),
            _: 1
          }),
          _createTextVNode(" 我的课程 ")
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(person.navList, (nav, navIndex) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["nav_item", [person.navActive === navIndex ?'nav_item_active':'']]),
              key: navIndex,
              onClick: ($event: any) => (navChange(nav, navIndex))
            }, _toDisplayString(nav.name), 11, _hoisted_5))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_6, [
          (person.data.list && person.data.list.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(person.data.list, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "main_item",
                    key: index,
                    onClick: ($event: any) => (_unref(toStudy)(item))
                  }, [
                    _createElementVNode("div", _hoisted_9, [
                      (item.CoverUrl)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: item.CoverUrl,
                            alt: ""
                          }, null, 8, _hoisted_10))
                        : (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            src: person.imgs[Math.floor(Math.random() * (person.imgs.length))],
                            alt: ""
                          }, null, 8, _hoisted_11)),
                      (!item.PlayStatus)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, "更新日期: " + _toDisplayString(item.UpdateTime), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            (item.PlayStatus === 1 && item.IsDayPlay===1)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                  _hoisted_15,
                                  _createTextVNode("今日直播 " + _toDisplayString(item.BeginTime), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (item.PlayStatus === 2)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                  _hoisted_17,
                                  _createTextVNode("直播中 ")
                                ]))
                              : _createCommentVNode("", true),
                            (item.IsDayPlay === 2)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                  _hoisted_19,
                                  _createTextVNode("下一场直播 " + _toDisplayString(item.BeginTime), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("p", _hoisted_21, _toDisplayString(item.Name), 1),
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, " 课时:" + _toDisplayString(item.ClassHour) + "节 ", 1),
                        (item.TeacherName)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_24, "主讲：" + _toDisplayString(item.TeacherName), 1))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ], 8, _hoisted_8))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_25, _hoisted_28)),
          (person.data.total > person.data.PageSize)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _createVNode(_component_el_pagination, {
                  layout: "prev, pager, next, jumper",
                  "current-page": person.data.PageIndex,
                  "page-size": person.data.PageSize,
                  total: person.data.total,
                  onCurrentChange: currentChange
                }, null, 8, ["current-page", "page-size", "total"]),
                _createElementVNode("div", _hoisted_30, "每页 " + _toDisplayString(person.data.PageSize) + " 条，共 " + _toDisplayString(person.data.total) + " 条", 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})